import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
    AccordionComponent,
    Button,
    GenericError,
    Input,
    ModalComponent,
    ModalHeader,
    ToastMessage,
} from "components";
import { ButtonRow, SeparateLine } from "styles/elements/main";
import Spinner from "components/Spinner";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import axios from "lib/api";
import useVerificationSubmit from "hooks/useVerificationSubmit";
import useFetchTruck from "../config/useFetchTruck";
import TruckInfo from "./truckInfo";
import LicenseInfo from "./licenseInfo";
import SupplierVerify from "./SupplierVerify";
import { getAllBoxTypes, getAllTruckTypes } from "../api";
import useVerificationObjection from "hooks/useVerificationObjection";

const Container = styled.div`
    margin-bottom: 27px;
`;
const VerifyTruckModal = ({ open, onClose, truckrId, truckStatus }) => {
    const { selectedTruckData: truckData, truckAttachments } = useFetchTruck(
        truckrId,
        "supplier,truckType,attachments"
    );
    const [allTruckClass, setTruckClass] = useState(null);
    const [allBoxesType, setAllBoxesType] = useState(null);

    const handleGetTruckClass = async () => {
        const data = await getAllTruckTypes();
        setTruckClass(data.map((name) => ({ value: truckData?.truckType?.value, label: name })));
    };
    const handleGetBoxTypes = async (truckClass) => {
        const data = await getAllBoxTypes(truckClass);
        setAllBoxesType(data);
    };
    const { objections, handleObjections } = useVerificationObjection();

    const { onSuccess, isLoading, handleReviewSubmition, backEndErorr } = useVerificationSubmit(
        objections,
        onClose,
        truckrId,
        "trucks"
    );
    useEffect(() => {
        if (truckData?.truckClass) {
            handleGetBoxTypes(truckData.truckClass);
        } else {
            setAllBoxesType([]);
        }
    }, [truckData?.truckClass]);

    useEffect(() => {
        handleGetTruckClass();
    }, []);
    return (
        <>
            <ModalComponent
                open={open}
                onClose={onClose}
                header={
                    <ModalHeader
                        entityId={truckrId}
                        entityName="Truck Profile Details"
                        entityStatus={truckStatus}
                    />
                }
                borderedHeader
                size="large"
            >
                <AccordionComponent
                    title="Truck Info"
                    defaultExpanded
                    body={
                        <TruckInfo
                            selectedTruckId={truckrId}
                            newTruckData={truckData}
                            isEditable={false}
                            isPlateNumberEditable={false}
                            allTruckClass={allTruckClass}
                            allBoxesType={allBoxesType}
                            isQARole
                            handleObjections={handleObjections}
                        />
                    }
                />
                <SeparateLine />
                <AccordionComponent
                    title="License Info"
                    defaultExpanded
                    body={
                        <LicenseInfo
                            truckAttachments={truckAttachments}
                            newTruckData={truckData}
                            isEditable={false}
                            selectedTruckId={truckrId}
                            isQARole
                            handleObjections={handleObjections}
                        />
                    }
                />
                <SeparateLine />
                <AccordionComponent
                    title="Supplier Info"
                    defaultExpanded
                    body={
                        <SupplierVerify
                            truckData={truckData}
                            isQARole
                            handleObjections={handleObjections}
                        />
                    }
                />
                <SeparateLine />
                <AccordionComponent
                    title="Others"
                    defaultExpanded
                    body={
                        <Container>
                            <Input
                                label="Notes"
                                isEditable={false}
                                value={truckData?.notes}
                            />
                        </Container>
                    }
                />
                {backEndErorr && <GenericError errorMassege={backEndErorr} />}
                <ButtonRow>
                    <Button
                        type="button"
                        onChange={onClose}
                        name="Cancel"
                        btnStyle="secondBtn"
                    />
                    <Button
                        btnStyle={isLoading || !(objections.length > 0) ? "disabled" : "primaryBtn"}
                        type="submit"
                        name={isLoading ? <Spinner /> : "Submit"}
                        disabled={!(objections.length > 0)}
                        icon={!isLoading && <AddCircleOutlineOutlinedIcon />}
                        onChange={handleReviewSubmition}
                    />
                </ButtonRow>
            </ModalComponent>
            {onSuccess && (
                <ToastMessage
                    name="supplier"
                    type="success"
                    text="verification success"
                    showToast={onSuccess}
                />
            )}
        </>
    );
};

export default VerifyTruckModal;
